import { render, staticRenderFns } from "./FinancialManagement.vue?vue&type=template&id=efc3c5fe&scoped=true"
import script from "./FinancialManagement.vue?vue&type=script&lang=js"
export * from "./FinancialManagement.vue?vue&type=script&lang=js"
import style0 from "./FinancialManagement.vue?vue&type=style&index=0&id=efc3c5fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc3c5fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efc3c5fe')) {
      api.createRecord('efc3c5fe', component.options)
    } else {
      api.reload('efc3c5fe', component.options)
    }
    module.hot.accept("./FinancialManagement.vue?vue&type=template&id=efc3c5fe&scoped=true", function () {
      api.rerender('efc3c5fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinancialManagementNew/FinancialManagement.vue"
export default component.exports